import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import FooterWeb from '../Components/Footer/footer-web';
import '../Components/Footer/footer.css';

export default function Footer() {
    const location = useLocation();
    const currentPage = useMemo(() => {
        if (location.pathname === '/contact') return 'Contact Us';
        // if (location.pathname === '/Dashboard') return 'All Reports';
        return 'Home';
    }, [location]);
    
    // if (isMobile) {
    //     if (currentPage === 'All Reports') return <></>;

    //     return <FooterWeb currentPage={currentPage} />;
    // }

    return <FooterWeb currentPage={currentPage} />;
}
